module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = 3